import { debugManager } from '@tunein/web-utils';
export const debug = debugManager.createDebugger('IMA', 'Google IMA Provider');
